'use strict';
import isFunction from 'lodash/isFunction';
import {Observable} from 'rxjs/Observable';
import {SortMethod} from '../../core-utilities/filters/SortMethod';

DataTagMixinFilter.$inject = [
  '$exceptionHandler',
  '$filter',
  'BaseFilterMixin',
  'FormResponseDomain',
];

export function DataTagMixinFilter(
  $exceptionHandler,
  $filter,
  BaseFilterMixin,
  FormResponseDomain,
) {
  return function DataTagMixinFilter(vm, $scope) {
    const tagListName = 'dataTagList';
    const responsesListName = 'dataTagResponses';
    const baseFilter = new BaseFilterMixin($scope, {
      vm: vm,
      filterTemplate: '',
      initialFilter: null,
      defaultSortProperty: 'name',
      filterOptions: {},
      enablePagination: true,
      pageSize: 30,
    });

    return {
      size: baseFilter.size,
      updateLimit: baseFilter.updateRenderLimit,
      initFiltering: initFiltering,
      destroyFiltering: baseFilter.destroyFiltering.bind(baseFilter),
    };

    function initFiltering(list) {
      if (!list || !isFunction(list.$toObservable)) {
        vm.filteredList = list;
        return;
      }
      baseFilter.registerFilter(tagListName);

      const listObservable = list.$toObservable();

      const formObservable = listObservable
        .switchMap(loadFormResponse);

      const arrayObservable = listObservable
        .map(filterFormlessTags);

      const sortedByOptionsObservable = Observable.combineLatest(
        arrayObservable,
        baseFilter.sortOptionsObservable,
        sortOptions);

      baseFilter.activeSubscriptions.push(Observable.combineLatest(
        sortedByOptionsObservable,
        baseFilter.filterObservable,
        $filter.$filterWithToString)
        .subscribe(baseFilter.updateFilter(tagListName, $scope), function delegateError(error) {
          $exceptionHandler(error, 'DataTagMixinFilter.toString: error occurred while updating list contents');
        }));

      baseFilter.activeSubscriptions.push(formObservable
        .subscribe(updateForms, function delegateError(error) {
          $exceptionHandler(error, 'DataTagMixinFilter.toString: error occurred while updating form list contents');
        }));

      function sortOptions(list, sortOptions) {
        const method = SortMethod.valueOf(sortOptions.currentMethod) || SortMethod.ASCENDING;
        return list.sort($filter.$sortByProperty('name', method.val, true));
      }
    }

    function filterFormlessTags(dataTagLinks) {
      const results = [];
      for (const id in dataTagLinks) {
        if (dataTagLinks.hasOwnProperty(id) && dataTagLinks[id].response)
          results.push(dataTagLinks[id]);
      }
      return results;
    }

    function loadFormResponse(dataTagLinks) {
      const results = {};
      for (const id in dataTagLinks) {
        if (dataTagLinks.hasOwnProperty(id) && dataTagLinks[id].response)
          results[id] = FormResponseDomain.$get(dataTagLinks[id].response);
      }
      return Promise.props(results);
    }

    function updateForms(forms) {
      $scope.$safeApply(function () {
        vm[responsesListName] = forms;
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/data-tags/services/DataTagMixinFilter.js